/**
 * Disability conditions + accessibility features — re-exported from generated
 * care taxonomy (Phase 6). Edit `shared/taxonomy/care_taxonomy.json` then
 * `python scripts/generate_care_taxonomy.py`.
 */

import {
  DISABILITY_CARE_CONDITION_OPTIONS,
  HANDICAP_ACCESSIBILITY_FEATURE_OPTIONS,
  HANDICAP_ACCESSIBILITY_LABEL_ALIASES,
} from "../generated/careTaxonomy";

export {
  DISABILITY_CARE_CONDITION_OPTIONS,
  HANDICAP_ACCESSIBILITY_FEATURE_OPTIONS,
  HANDICAP_ACCESSIBILITY_LABEL_ALIASES,
};

/**
 * Legacy edit-form values that were physical features but stored under disability support.
 * Derived from canonical handicap options plus alias keys so lists stay in sync.
 */
export const LEGACY_DISABILITY_PHYSICAL_FEATURES = new Set([
  ...HANDICAP_ACCESSIBILITY_FEATURE_OPTIONS,
  ...Object.keys(HANDICAP_ACCESSIBILITY_LABEL_ALIASES),
]);

const WHEELCHAIR_ACCESSIBILITY_MATCHERS = [
  "wheelchair accessible",
  "wheelchair access",
  "wheel chair",
] as const;

export function normalizeHandicapAccessibilityLabel(label: string): string {
  const trimmed = label.trim();
  if (!trimmed) {
    return trimmed;
  }
  return HANDICAP_ACCESSIBILITY_LABEL_ALIASES[trimmed] ?? trimmed;
}

export function isWheelchairAccessibilityLabel(label: string): boolean {
  const normalized = normalizeHandicapAccessibilityLabel(label).toLowerCase();
  return WHEELCHAIR_ACCESSIBILITY_MATCHERS.some((matcher) =>
    normalized.includes(matcher)
  );
}
